import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import FilterChip from "../Filters/FilterChip";
import AddTopics from "./AddTopics";
import { Watchlist } from '../../services/Contexture/Watchlist';
import { toast } from 'react-toastify';


const WatchlistTags = ({
    allTags = [],
    docId,
    updateTagSet,
    selectedTags,
    documentTags = [],
    showActions = false,
    fetchTags,
    profileId = '',
}) => {
    const [showAddTopicsPopover, setShowAddTopicsPopover] = useState(false);
    const [showMoreTags, setShowMoreTags] = useState(false);

    const handleRemoveTag = async (tagName) => {
        try {
            await Watchlist.removeTag(docId, { tag: tagName, profileId: profileId, });
            toast.success(`Tag "${tagName}" removed successfully!`);
            updateTagSet?.('remove', [tagName]);
        } catch (error) {
            toast.error(`Failed to remove tag "${tagName}"`);
            console.error('Error removing tag:', error);
        }
    };

    const displayTags = documentTags || [];
    const visibleTags = displayTags.slice(0, 3);
    const hiddenTags = displayTags.slice(3);

    return (
        <div className='doc-card-tags-wrapper'>
            <div className="filter-chips-container">
                {visibleTags.map((tag) => (
                    <FilterChip
                        key={tag}
                        showClear={showActions}
                        value={tag}
                        truncate={true}
                        onClear={() => handleRemoveTag(tag)}
                    />
                ))}

                {hiddenTags.length > 0 && (
                    <OutsideClickHandler
                        onOutsideClick={() => setShowMoreTags(false)}
                    >
                        <div className="position-relative">
                            <div className='add-and-more-count' onClick={() => {
                                setShowAddTopicsPopover(false);
                                setShowMoreTags(!showMoreTags);
                            }}>
                                <span className="btn-text">+{hiddenTags.length} more</span>
                            </div>
                            {showMoreTags && (
                                <div className="show-topic-popover filters-popover">
                                    <ul className="filters-popover-list">
                                        <li className="filters-popover-row">
                                            <div className="tags-show-popover">
                                                <div className="filter-chips-container">
                                                    {hiddenTags.map((tag) => (
                                                        <FilterChip
                                                            key={tag}
                                                            showClear={showActions}
                                                            value={tag}
                                                            onClear={() => handleRemoveTag(tag)}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </OutsideClickHandler>
                )}

                {showActions ?
                    <div className="position-relative">
                        <div className="add-and-more-count" onClick={() => {
                            setShowMoreTags(false);
                            setShowAddTopicsPopover(true);
                        }}>
                            <span className="btn-text">+Add tags</span>
                        </div>
                        {showAddTopicsPopover && (
                            <AddTopics
                                tags={allTags}
                                docId={docId}
                                profileId={profileId}
                                setShowAddTopicsPopover={setShowAddTopicsPopover}
                                onTagsUpdate={updateTagSet}
                                documentTags={documentTags}
                                fetchTags={fetchTags}
                            />
                        )}
                    </div>
                    : null
                }
            </div>
        </div>
    )
}
export default WatchlistTags;